import { render, staticRenderFns } from "./RecommendHotel2.vue?vue&type=template&id=21a43931&scoped=true"
import script from "./RecommendHotel2.vue?vue&type=script&lang=js"
export * from "./RecommendHotel2.vue?vue&type=script&lang=js"
import style0 from "./RecommendHotel2.vue?vue&type=style&index=0&id=21a43931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a43931",
  null
  
)

export default component.exports